import React, { Component } from "react";
import { Button } from "antd";
import AccessImg from "../image/accessImg.png";
//import { Redirect } from "react-router-dom"; 
import { authUserData, redirectIfLoggedIn } from "../utils/Helper"; // Import redirectIfLoggedIn

class NotAccess extends Component {
    render() {
        const isAuthenticated = authUserData(); // Get authentication status from your helper function

        if (!isAuthenticated) {
            return (
                <div className="access-denied">
                    <div className="denied">
                        <div className="container">
                            <div className="imgdiv">
                                <img alt="icon" src={AccessImg}></img>
                            </div>
                            <h3>Access Denied!</h3>
                            <h5>Do not have permission to access this page</h5>
                            <div className="btnrow">
                                <Button type="primary" onClick={redirectIfLoggedIn}>Go Back</Button>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
          // return <Redirect to="/dashboard" />;
            // You can handle the case where the user is logged in here, maybe by redirecting them to another page.
            // You can also add a message or perform other actions as needed.
            return (
                <div>
                    <p>You are logged in and have permission to access this page.</p>
                </div>
            );
        }
    }
}

export default NotAccess;
